import * as React from 'react'

import { margin, styled, Text } from '@thg-commerce/gravity-theme'
import { Separator } from '@thg-commerce/gravity-elements'
import { i18n, useSiteConfig } from '@thg-commerce/enterprise-core'
import { Margin } from '@thg-commerce/gravity-theme/margin'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'

const Message = styled.p<{ margin?: Margin }>`
  ${Text('bodyText', 'default')};
  ${(props) => props.margin && margin(props.margin)};
`

export const FreeDeliveryIndicator = () => {
  const { showProductPageFreeDeliveryText } = useSiteConfig()
  const theme = useTheme()
  const i18nText = {
    freeDelivery: {
      text: i18n('product.freedelivery.text'),
      href: i18n('product.freedelivery.href'),
    },
  }

  if (!showProductPageFreeDeliveryText) return null

  return i18nText.freeDelivery.text ? (
    i18nText.freeDelivery.href ? (
      <React.Fragment>
        <a href={i18nText.freeDelivery.href} rel="nofollow noreferrer">
          <Message margin={theme.pageTheme.freeDeliveryIndicator?.margin}>
            {i18nText.freeDelivery.text}
          </Message>
        </a>
        <Separator withSpacing />
      </React.Fragment>
    ) : (
      <React.Fragment>
        <Message margin={theme.pageTheme.freeDeliveryIndicator?.margin}>
          {i18nText.freeDelivery.text}
        </Message>
        <Separator withSpacing />
      </React.Fragment>
    )
  ) : null
}
